import Vue from "vue";
// import VueRouter from "vue-router";
import VueRouter from 'vue-router'
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
// home
import Home from "@/views/home/Home";
import Index from "@/views/home/Index";
import Register from "@/views/home/Register";
import Docinfo from "@/views/home/Docinfo";
import Yyjj from "@/views/yyjj/Yyjj";
import Activity from "@/views/activity/Activity";

Vue.use(VueRouter);

const routes = [
	{
		path: "",
		redirect: "/home"
	},
	{path: '/home',name: 'Home',component: Home,children:[
		{path:'',redirect:'/home/index'},
		{path: 'index',name: 'Index',component: Index},
		{path: 'yyjj',name: 'Yyjj',component: Yyjj},
		{path: 'activity',name: 'Activity',component: Activity},
		
	]},
	{
		name: 'Docinfo',
		path: "/docinfo",
		component: Docinfo,
	},
	{
		name: 'Register',
		path: "/register",
		component: Register,
	},
	{
		name: 'Yyjj',
		path: "/yyjj",
		component: Yyjj,
	},
	{
		name: 'Activity',
		path: "/activity",
		component: Activity,
	}
];
// const router = new VueRouter({
//   mode: "history",
//   base: process.env.BASE_URL,
//   routes
// });
const router = new VueRouter({
	routes
});
export default router;
